import React from "react";
import { useNavigate } from "react-router-dom";
import ContactPage from "./ContactPage";
import { motion } from "framer-motion";

const Wordpress = () => {
  const navigate = useNavigate();
  const handleClicked = () => {
    navigate("/contact");
  };
  return (
    <>
      {/* <section className="section1">
        <div>
          <div className="serviceclass1">
            <img src="/images/background.webp" alt="" />
          </div>
          <div className="serviceclass2">
            <h4 className="fsh2 mb2 serviceclass2h4">
              Leading Wordpress Developement Company
            </h4>
            <p className="webservicep fsp col-10">
            We offer custom WordPress development services to build high-performance, secure, and scalable websites. 
            </p>
            <button
              className="button"
              style={{ textAlign: "right" }}
              onClick={handleClicked}
            >
              <span className="text">Let's Talk &rarr;</span>
              <div className="circle"></div>
            </button>
          </div>
        </div>
      </section> */}
      <section className="uiuxsection">
        <div className="websection1">
          <motion.h2
            className="websection2"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Leading Wordpress Development Company
          </motion.h2>
          <motion.p
            className="fsp websection3"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          >
            We offer custom WordPress development services to build
            high-performance, secure, and scalable websites.
          </motion.p>
          <motion.button
            className="uiuxbutton"
            onClick={handleClicked}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Let's talk &#8594;
          </motion.button>
        </div>
      </section>
      <section
        className="m"
        style={{
          display: "flex",
          justifyContent: "space-around",
          background: "#f1f3f5",
          padding: "20px",
          borderRadius: "10px"
        }}
      >
        <div className="cb1 flex-column">
          <div className="cb2">
            <div className="d-flex flex-column justify-content-center align-items-start gap-2">
              <img
                src="/images/Fontend1.webp"
                alt=""
                className="img-fluid imag5"
                style={{
                  height: "18px",
                  width: "90%",
                  objectFit: "cover"
                }}
              />
              <img
                src="/images/Fontend2.webp"
                alt=""
                className="img-fluid imag6"
                style={{
                  height: "18px",
                  width: "90%",
                  objectFit: "fill"
                }}
              />
              <img
                src="/images/Fontend3.webp"
                alt=""
                className="img-fluid imag7"
                style={{ height: "18px", objectFit: "cover" }}
              />
              <img
                src="/images/Fontend4.webp"
                alt=""
                className="img-fluid imag8"
                style={{
                  height: "18px",
                  width: "90%",
                  objectFit: "fill"
                }}
              />
            </div>
          </div>
          <div>
            <img
              src="/images/cssol.webp"
              alt=""
              className="img-fluid"
              height="220px"
              width="220px"
              style={{
                height: "220px",
                display: "flex",
                alignItems: "left"
              }}
            />
          </div>
        </div>
        <div className="uiuxmobileres text-start">
          <h3 className="fsh3">Wordpress Development Services</h3>
          <p className="fsp">
            We offer custom WordPress development services to build
            high-performance, secure, and scalable websites. Our expertise
            includes theme customization, plugin development, eCommerce
            solutions (WooCommerce), SEO optimization, and website maintenance.
            We create responsive, user-friendly, and fast-loading websites
            tailored to your business needs. Whether you need a corporate site,
            a blog, or an online store, our WordPress experts ensure a seamless
            digital experience. Elevate your online presence with a powerful
            WordPress website designed for success!
          </p>
          <div className="tags">
            {[
              "Comprehensive Planning",
              "Incorporate Responsive Design",
              "Security Measures"
            ].map((text, index) => (
              <div key={index} className="d-flex align-items-center gap-2">
                <img
                  src="/images/tick.webp"
                  height="30px"
                  width="30px"
                  alt=""
                  style={{ height: "30px", width: "30px" }}
                />
                <span className="fsp">{text}</span>
              </div>
            ))}
          </div>
          <div className="uiux d-flex flex-wrap mt-3">
            {[
              "ecom1",
              "ecom2",
              "seoser5",
              "soma4",
              "ecom3",
              "ecom4",
              "seoser7"
            ].map((tool, index) => (
              <div key={index} className="d-flex align-items-center gap-2">
                <img
                  src={`/images/${tool}.webp`}
                  alt=""
                  style={{ height: "35px" }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      <section>
        <ContactPage />
      </section>
    </>
  );
};

export default Wordpress;
